import { render } from "./BaseSetting.vue?vue&type=template&id=48d45b28&scoped=true"
import script from "./BaseSetting.vue?vue&type=script&lang=jsx"
export * from "./BaseSetting.vue?vue&type=script&lang=jsx"

import "./BaseSetting.vue?vue&type=style&index=0&id=48d45b28&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d45b28"]])

export default __exports__